import React, { useState, useEffect, ChangeEvent } from 'react';
import { Breadcrumbs, Typography, TableCell, TableRow, } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import AddButton from '../../components/Button/AddButton';
import TableComponent from '../../components/Table/TableComponent';
import TablePaginationComponent from '../../components/Table/TablePaginationComponent';
import ActionButtons from '../../components/Button/ActionButtons';
import { deleteRequest, getRequest } from './baseservice';
import LoadingAnimation from '../../components/LoadingAnimation';
import ConfirmationDialog from '../../components/Dialog/ConfirmationDialog';
import AllergyReactionMasterDialog from './Master Dialog/allergyreactiondialog';
import { BASE_URL, getAxiosConfig } from '../../components/interface/Config';
import { apiHandler } from '../../services/authService';
interface ApiResponse {
  code: number;
  message: string;
  data: {
    custom_masters: AllergyreactionMaster[];
    pagination: Pagination;
  };
}

export interface AllergyreactionMaster {
  id: number;
  provider_id: number;
  master_type_slug: string;
  name: string;
  slug: string;
  attributes: {

  };
  is_active: number;
}

interface Pagination {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
}
const AllergyReaction: React.FC = () => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [allergies, setAllergies] = useState<AllergyreactionMaster[]>([]);
  const [totalAllergies, setTotalAllergies] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');
  const location = useLocation();
  const [selectedAllergy, setSelectedAllergy] = useState<AllergyreactionMaster | null>(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteAllergyId, setDeleteAllergyId] = useState<number | null>(null);

  const { providerId, userid } = location.state || {};
  const fetchAllergies = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        limit: rowsPerPage.toString(),
        page: (page + 1).toString(),
        slug: 'reaction',
        order_by: 'name',
        dir: '1',
        user_id: userid.toString(),
      });

      const url        = `${BASE_URL}/resource/custom_masters?${queryParams}`;
      const data   = await apiHandler('', 'GET',{}, url);

      if (!data) {
          throw new Error("No response received from the server");
      }

      // const response = await fetch(`https://telegaruda-api.a2zhealth.in/v1/resource/custom_masters?${queryParams}`, {
      //   method: 'GET',
      //   headers: { ...getAxiosConfig().headers },
      // });


      // const data = await response.json();
      console.log('page', data.data.pagination);
      setAllergies(data.data.custom_masters || []);
      console.log("Set Allergies:", data.data.custom_masters);

      setTotalAllergies(data.data.pagination?.total || 0);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch allergies');
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchAllergies();
  }, [page, rowsPerPage]);

  const handleBack = () => navigate(-1);
  const handleClickOpen = () => setOpenDialog(true);
  const handleClose = () => {
    setOpenDialog(false);  // Close the dialog
    fetchAllergies();  // Fetch the updated allergies data after closing
  };
  const handleSave = () => {
    setOpenDialog(false);  // Close the dialog
    fetchAllergies();  // Fetch the updated allergies data after saving
  };

  const handleDelete = async () => {
    if (deleteAllergyId) {
      try {
        await deleteRequest<ApiResponse>(`resource/custom_masters/${deleteAllergyId}`);
        setConfirmDelete(false);
        fetchAllergies(); // Refresh allergy data after deletion
      } catch (err) {
        setError('Failed to delete allergy');
      }
    }
  };


  const renderRow = (row: AllergyreactionMaster, index: number) => (
    <TableRow key={row.id}>
      <TableCell className="font-jost" sx={{ fontFamily: 'Jost, sans-serif', fontSize: '1rem' }}> {page * rowsPerPage + index + 1}</TableCell>
      <TableCell className="font-jost" sx={{ fontFamily: 'Jost, sans-serif', fontSize: '1rem' }}>{row.name}</TableCell>
      <TableCell className="font-jost" sx={{ fontFamily: 'Jost, sans-serif', fontSize: '1rem' }}>{row.slug}</TableCell>
      <TableCell className="font-jost" sx={{ fontFamily: 'Jost, sans-serif', fontSize: '1rem' }}>
        <ActionButtons
          onEdit={() => {
            setSelectedAllergy(row);  // Set the selected allergy
            setOpenDialog(true);       // Open the dialog
          }}
          onDelete={() => {
            setDeleteAllergyId(row.id); // Set the selected allergy ID to delete
            setConfirmDelete(true); // Show the confirmation dialog
          }}

        />
      </TableCell>
    </TableRow>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
      <div className="flex justify-between items-center w-full mt-20">
        <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: 3 }} className='mt-2'>
          <Typography color="primary" onClick={handleBack} style={{ cursor: 'pointer' }}>
            Back
          </Typography>
          <Typography color="primary" fontWeight="bold">
            Allergy Reaction
          </Typography>
        </Breadcrumbs>
        <AddButton text="Add" onClick={handleClickOpen} />
      </div>

      {loading ? (
        <LoadingAnimation />
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          {/* Add a scrollable wrapper for the table */}
          <div style={{ flex: 1, overflowY: 'auto', maxHeight: '485px', width: '100%' }} className='mt-6'>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              {/* Table Header */}
              <thead>
                <tr style={{ position: 'sticky', top: 0, backgroundColor: 'black', color: 'white', zIndex: 1 }}>
                  {['S.No', 'Name', 'Code', 'Actions'].map((header, index) => (
                    <th
                      key={index}
                      style={{
                        padding: '10px',
                        borderBottom: '1px solid #ddd',
                        textAlign: 'left',
                        backgroundColor: 'black', // Black background for header
                        color: 'white', // White text for header
                      }}

                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              {/* Table Body */}
              <tbody className='bg-white'>
                {allergies.map((allergy, index) => renderRow(allergy, index))}
              </tbody>
            </table>
          </div>

          <TablePaginationComponent
            count={totalAllergies}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={(_event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              const newRowsPerPage = parseInt(event.target.value, 10);
              setRowsPerPage(newRowsPerPage);
              setPage(0);
            }}
          />
        </>
      )}

      <AllergyReactionMasterDialog
        open={openDialog}
        onClose={handleClose}
        onSave={handleSave}
        providerid={providerId}
        selectedAllergy={selectedAllergy}
      />

      <ConfirmationDialog
        open={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        onConfirm={handleDelete}
        title="Are you sure you want to delete?"
      />
    </div>

  );

};

export default AllergyReaction;
